const o=["AT","CH","DE","NL"];export{o as ALLOWED_COUNTRIES};
//# sourceMappingURL=config.js.map
